import { useAbility } from '@casl/react';

import { AbilityContext } from '@config/canAbility';

const useCustomAbility = () => {
  return useAbility(AbilityContext);
};

export default useCustomAbility;
